import { config } from '@/_helpers'
import axios from "axios"

let axiosHeaders = { 'Content-Type': 'application/json' }

export const $_sync_server = axios.create({
  baseURL: config.syncUrl,
  headers: axiosHeaders
})

export const syncService = {
  syncCategories,
  syncCategoriesByCatalog,

  syncJudges,

  syncNewCase,
  syncNewCaseByPeriod,

  syncCases,
  syncCasesJudgesYear,
  syncCasesJudgesToDate,

  syncTemplates,
  syncDocs
}


function syncCategories() {
    return $_sync_server.get("categories").then(response => response.data)
}

function syncCategoriesByCatalog(catalogs) {
  return $_sync_server.get("categories?catalogs=" + catalogs).then(response => response.data)
}

function syncJudges() {
  return $_sync_server.get("judges").then(response => response.data)
}


function syncNewCase() {
  return $_sync_server.get("newcase").then(response => response.data)
}

function syncNewCaseByPeriod(startDate, endDate) {
  return $_sync_server.get("newcase?dateFrom=" + startDate + "&dateTo=" + endDate).then(response => response.data)
}

function syncCases() {
  return $_sync_server.get("cases").then(response => response.data)
}

function syncCasesJudgesYear(judgeGaseUid) {
  return $_sync_server.get("cases?judge=" + judgeGaseUid).then(response => response.data)
}

function syncCasesJudgesToDate(judgeGaseUid, endDate) {
  return $_sync_server.get("cases?judge=" + judgeGaseUid + "&date=" + endDate).then(response => response.data)
}

  
function syncTemplates(judgeUUID) {
  return $_sync_server.get("template?judge=" + judgeUUID).then(response => response)
}



function syncDocs(caseUUID) {
  return $_sync_server.get("get/docs?caseId=" + caseUUID).then(response => response.data)
}

// + /sync/start/judges
// + sync/start/categories
// + sync/start/categories?catalogs={список каталогов через запятую}
// + /sync/start/newcase?dateFrom=2019-08-01&dateTo=2019-08-10  за период включительно
// + /sync/start/newcase за текущий день только

// /sync/start/cases   - все судьи все дела за текущий год
// /sync/start/template?judge={UUID судьи}  - все шаблоны судьи
// /sync/start/cases?judge={идентификатор судьи}  - все дела судьи за текущий год
// /sync/start/cases?judge={идентификатор судьи}&date={дата до}  - все дела судьи за текущий год до даты
